import _ from 'lodash';
import memoizeOne from 'memoize-one';
import { createSelector } from 'reselect';

import { formatPriorToDisplayName } from 'constants/condition';
import { findPriorToOption } from 'utils/priorTo';

import { selectUnderwriting } from './underwriting.selectors';

export const selectPriorToTypes = createSelector(selectUnderwriting, ({ priorTo }) =>
  _.sortBy(priorTo ?? [], 'order'),
);

export const selectPriorToAllOptions = createSelector(selectPriorToTypes, priorToTypes =>
  priorToTypes.map(({ id, name, stage, isStandard, isEnabled, order }) => ({
    value: id,
    name,
    stage,
    isStandard: !!isStandard,
    isEnabled: isEnabled !== false,
    order,
  })),
);

export const selectPriorTo = createSelector(selectPriorToAllOptions, options =>
  options.filter(({ isEnabled }) => isEnabled),
);

export const selectPriorToNameByValue = memoizeOne(value =>
  createSelector(
    selectPriorToAllOptions,
    options =>
      findPriorToOption({ options, priorToTypeId: value, priorToType: value })?.name ??
      formatPriorToDisplayName(value),
  ),
);
